module.exports = __webpack_public_path__ + "static/media/score-rubric.9b740356.png";